import { post } from '@/common/request'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import { im } from './im'

export default new Vuex.Store({
  modules: {
    im
  },
  state: {
    token: '',
    userInfo: {},
    newNoticeNum: 0,
    // 备案信息(公司名称)
    companyName: '',
    // 备案信息(备案号)
    beianNo: '',
    // projectName: "沐知云·融合教育一站式成长支持平台",
    projectName: "沐知云·融合教育",
  },
  mutations: {
    /** 初始化用户信息  */
    init(state) {
      var tk = localStorage.getItem('token')
      var ui = localStorage.getItem('user_info')
      this.commit('saveToken', tk || '');
      this.commit('saveUserInfo', JSON.parse(ui) || {});
    },
    /** 保存token */
    saveToken(state, val) {
      state.token = val;
      localStorage.setItem('token', val)
      if (state.token) {
        this.dispatch('getUserInfo');
        this.dispatch('getNewNoticeNum');
        this.commit('im_auth')
      }
    },
    /** 保存userInfo */
    saveUserInfo(state, val) {
      state.userInfo = val || {};
      localStorage.setItem('user_info', JSON.stringify(val))
    },
    /** 退出  */
    loginOut(state) {
      state.newNoticeNum = 0;
      state.token = '';
      state.userInfo = {};
      localStorage.removeItem('token')
      localStorage.removeItem('user_info')
      state.im.person_list = [];
      state.im.new_im_msg = {};
    }
  },
  getters: {
  },
  actions: {
    // 获取系统新消息数量
    async getNewNoticeNum({ state }) {
      if (localStorage.getItem('token')) {
        const res = await post('v1.chat/get_user_msgnum');
        state.newNoticeNum = (res.data || {}).unread_num || 0;
      } else {
        state.newNoticeNum = 0;
      }
    },
    // 更新用户信息
    async getUserInfo({ commit }) {
      // const res = await post('用户信息接口');
      // commit('saveUserInfo', res.data || {});
    },
    // 系统配置信息
    async getCSystemInfo({ state }) {
      // const res = await post('系统配置接口');
      // state.companyName = res.data.xxx;
      // state.beianNo = res.data.xxx;
    },
  },
})
